import client from '@src/lib/api/client'

import { DeleteItemResponse, InsertItemResponse } from '@src/interface/api/response.interface'
import { GetCardResBody, BillingKeyCreationDto } from '@src/type/payment'

export async function getCard(): Promise<GetCardResBody> {
	const response = await client.get<GetCardResBody>('/payments/cards')

	if (response.data.success !== 1) {
		throw new Error('fail to get card')
	}

	return response.data
}

export async function deleteCard(cardNo: number): Promise<void> {
	const response = await client.delete<DeleteItemResponse<Record<string, any>>>(
		`/payments/cards/${cardNo}`,
	)

	if (response.data.success !== 1) {
		throw new Error('fail to delete card')
	}
}

export async function createBillingKey(createDto: BillingKeyCreationDto): Promise<void> {
	const response = await client.post<InsertItemResponse<Record<string, any>>>(
		'/payments/billing-key',
		createDto,
	)

	if (response.data.success !== 1) {
		throw new Error('fail to create billing key')
	}
}
